import type { AxiosInstance } from 'axios'

import { ProductDetailInterface } from '../../interfaces/product'

export const getProductDetail = (api: AxiosInstance) => (
  productId: string
): Promise<ProductDetailInterface> =>
  api.get(`/v1.0/admin/products/${productId}`)
